import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { BaseComponent } from '../base/base.component';
import { IdDescription } from '../../models';
import { AuthService } from '../../../auth';
import { CurrencyForUserReferenceService, CurrencySelectService, UserCurrencyReferenceService } from '../../services';

@Component({
  selector: 'app-currency-select',
  templateUrl: './currency-select.component.html',
  styleUrl: './currency-select.component.scss',
  imports: [FormsModule, AsyncPipe],
})
export class CurrencySelectComponent extends BaseComponent implements OnInit {
  protected readonly authService = inject(AuthService);
  protected readonly currencySelectService = inject(CurrencySelectService);
  private readonly userCurrencyReferenceService = inject(UserCurrencyReferenceService);
  private readonly currencyReferenceService = inject(CurrencyForUserReferenceService);

  currencies$: Observable<IdDescription[]>;

  private userCurrency: IdDescription;

  ngOnInit() {
    this.userCurrencyReferenceService
      .get()
      .pipe(this.untilDestroyed())
      .subscribe((currencies) => {
        this.userCurrency = currencies ? currencies[0] : undefined;
        this.currencySelectService.getCurrency().subscribe(() => this.getReferenceData());
      });
  }

  private getReferenceData() {
    this.currencies$ = this.currencyReferenceService.get().pipe(
      this.untilDestroyed(),
      tap((currencies) => {
        if (!this.currencySelectService.currentCurrency && !!currencies?.length && this.userCurrency) {
          this.currencySelectService.setCurrency(this.userCurrency.id).subscribe();
        }
      }),
    );
  }

  setCurrency(event: any) {
    this.currencySelectService.setCurrency(event.target.value).subscribe();
  }
}
